// Set up all Venues with appropriate variables including Disploay name, city, website URL and blob url
const venues = [
  {
    code: "HQ",
    name: "HQ",
    city: "london",
    url: "electricshuffle.com/uk/london",
    azure_url: "https://esstories-ukso1.streaming.media.azure.net/",
    blob_url: "https://esstoriesvideostorage.blob.core.windows.net/",
    feedback_url: "",
  },
  {
    code: "CANAR",
    name: "CanaryWharf",
    display_name: "Canary Wharf",
    city: "london",
    url: "electricshuffle.com/uk/london",
    azure_url: "https://esstories-ukso1.streaming.media.azure.net/",
    blob_url: "https://esstoriesvideostorage.blob.core.windows.net/",
    feedback_url: "https://bit.ly/49NALtj",
    google_url: "https://g.page/r/CRCTau0fK2vUEAI/review",
  },
  {
    code: "LDNBR",
    name: "LondonBridge",
    display_name: "London Bridge",
    city: "london",
    url: "electricshuffle.com/uk/london",
    azure_url: "https://esstories-ukso1.streaming.media.azure.net/",
    blob_url: "https://esstoriesvideostorage.blob.core.windows.net/",
    feedback_url: "https://bit.ly/4grVZzl",
    google_url: "https://g.page/r/CRt3zuAk2gbwEAI/review",
  },
  {
    code: "LEEDS",
    name: "Leeds",
    city: "leeds",
    url: "electricshuffle.com/uk/leeds",
    azure_url: "https://esstories-ukso1.streaming.media.azure.net/",
    blob_url: "https://esstoriesvideostorage.blob.core.windows.net/",
    feedback_url: "https://bit.ly/4gM6AFd",
    google_url: "https://g.page/r/CXjbuFIUXsOKEAI/review",
  },
  {
    code: "MANCH",
    name: "Manchester",
    city: "manchester",
    url: "electricshuffle.com/uk/manchester",
    azure_url: "https://esstories-ukso1.streaming.media.azure.net/",
    blob_url: "https://esstoriesvideostorage.blob.core.windows.net/",
    feedback_url: "https://bit.ly/3ZRlPFN",
    google_url: "https://g.page/r/CXOxvvS37bheEAI/review",
  },
  {
    code: "KINGS",
    name: "KingsCross",
    display_name: "King's Cross",
    city: "london",
    url: "electricshuffle.com/uk/london",
    azure_url: "https://esstories-ukso1.streaming.media.azure.net/",
    blob_url: "https://esstoriesvideostorage.blob.core.windows.net/",
    feedback_url: "https://bit.ly/4119sbW",
    google_url: "https://g.page/r/CchAd7jp8WylEBM/review",
  },
  {
    code: "AUSTI",
    name: "Austin",
    city: "austin",
    url: "electricshuffle.com/us/austin",
    azure_url: "https://esusastoriesmedia-usw22.streaming.media.azure.net/",
    blob_url: "https://esusastoriesvideos.blob.core.windows.net/",
    feedback_url: "",
    google_url: "http://bit.ly/420EI9A",
  },
  {
    code: "DALLA",
    name: "Dallas",
    city: "dallas",
    url: "electricshuffle.com/us/dallas",
    azure_url: "https://esusastoriesmedia-usw22.streaming.media.azure.net/",
    blob_url: "https://esusastoriesvideos.blob.core.windows.net/",
    feedback_url: "",
    google_url: "http://bit.ly/3JwwOOh",
  },
  {
    code: "BROAD",
    name: "NYC",
    city: "nyc",
    url: "electricshuffle.com/us/nyc",
    azure_url: "https://esusastoriesmedia-usw22.streaming.media.azure.net/",
    blob_url: "https://esusastoriesvideos.blob.core.windows.net/",
    feedback_url: "",
    google_url: "https://bit.ly/3W7slb9",
  },
  {
    code: "CHICA",
    name: "Chicago",
    city: "chicago",
    url: "electricshuffle.com/us/chicago",
    azure_url: "https://esusastoriesmedia-usw22.streaming.media.azure.net/",
    blob_url: "https://esusastoriesvideos.blob.core.windows.net/",
    feedback_url: "",
    google_url: "https://bit.ly/3RwDlvx",
  },
];

// function to get Venue array based on story data venue code
export const getVenueName = (venue_code) => {
  let venue = {};
  venues.forEach((item) => {
    if (venue_code.toUpperCase() == item.code) {
      venue = {
        venue_name: item.name,
        venue_display_name: item.display_name || item.name,
        city_name: item.city,
        city_url: item.url,
        azure_url: item.azure_url,
        blob_url: item.blob_url,
        feedback_url: item.feedback_url,
        google_url: item.google_url,
      };
    }
  });
  return venue;
};
